import React from 'react';
import { useController } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import RadioGroup from '@grnhse/seedling/lib/birch/components/radio_group';
import { SCORECARD_STATUS } from 'talent_search/shared/types';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.feedback_status');

export const FeedbackStatusContent = () => {
  const { field } = useController({ name: 'feedbackStatus' });

  const selectedValue =
    field.value && field.value !== SCORECARD_STATUS.ALL
      ? field.value
      : undefined;

  const handleChange = (value?: string | number) => {
    field.onChange((value ?? SCORECARD_STATUS.ALL) as SCORECARD_STATUS);
  };

  return (
    <Stack spacing={2} direction="column">
      <RadioGroup
        name={field.name}
        ariaLabel={t('description')}
        options={[
          { label: t('radio_with'), value: SCORECARD_STATUS.COMPLETED },
          { label: t('radio_without'), value: SCORECARD_STATUS.INCOMPLETE },
        ]}
        value={selectedValue}
        onChange={handleChange}
        clearable
      />
    </Stack>
  );
};
